import Badge from "../components-2022/Badge";
import BaseAlert from "../components-2022/BaseAlert";
import BaseButton from "../components-2022/BaseButton";
import BaseCheckbox from "../components-2022/BaseCheckbox";
import BaseInput from "../components-2022/BaseInput";
import BasePagination from "../components-2022/BasePagination";
import BaseProgress from "../components-2022/BaseProgress";
import BaseRadio from "../components-2022/BaseRadio";
import BaseSlider from "../components-2022/BaseSlider";
import BaseSwitch from "../components-2022/BaseSwitch";
import Card from "../components-2022/Card";
import Icon from "../components-2022/Icon";

export default {
  install(Vue) {
    Vue.component(Badge.name, Badge);
    Vue.component(BaseAlert.name, BaseAlert);
    Vue.component(BaseButton.name, BaseButton);
    Vue.component(BaseInput.name, BaseInput);
    Vue.component(BaseCheckbox.name, BaseCheckbox);
    Vue.component(BasePagination.name, BasePagination);
    Vue.component(BaseProgress.name, BaseProgress);
    Vue.component(BaseRadio.name, BaseRadio);
    Vue.component(BaseSlider.name, BaseSlider);
    Vue.component(BaseSwitch.name, BaseSwitch);
    Vue.component(Card.name, Card);
    Vue.component(Icon.name, Icon);
  }
};
